import BaseService from "./BaseService";
// import { mockRequest, makeLevelReading } from "./MockService";
import { TanksLevelsReadings } from "../core/models/TanksLevelsReadings";
import addTime, { isDateValid } from "../helpers/datetime";
import { isArrayValid } from "../helpers/utility";
import ILevelByTankParams from "../core/contracts/ILevelByTankParams";

export type TankLevelServiceFetchParams = {
  tanks_ids: string[];
  startDate?: Date;
  endDate?: Date;
  pageSize?: number;
  page?: number;
};

export default class TankLevelService extends BaseService {
  async fetch(params: TankLevelServiceFetchParams): Promise<TanksLevelsReadings> {
    const { tanks_ids, startDate, endDate, pageSize, page } = params;

    const startDateFilter = isDateValid(startDate)
      ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        startDate!.toISOString()
      : addTime(new Date(), -1, "week").toISOString();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const endDateFilter = isDateValid(endDate) ? endDate!.toISOString() : new Date().toISOString();

    try {
      if (!isArrayValid(tanks_ids)) {
        return new Promise((_, rej) => rej("invalid tanks ids!"));
      }

      const params: ILevelByTankParams[] = tanks_ids.map((id) => {
        return {
          tank_id: id,
          start_date: startDateFilter,
          end_date: endDateFilter,
        };
      });

      const APIResponse = new BaseService().post<
        { tanks: TanksLevelsReadings },
        ILevelByTankParams[]
      >(`/level_by_tank/`, params);

      return (await APIResponse)?.tanks ?? [];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("TankLevelService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
